export default (ms): Promise<void> => {
  return new Promise((res) => {
    setTimeout(res, ms);
  });
};
